<div class='fullcontainer'>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Contract was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Contract - {{ this.contract.name }}</h1>
    <app-audit-line [data]='this.contract'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-contract-form [contractProducts]='this.contractProducts' [customer]='this.customer' [contract]='this.contract'></app-contract-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/contracts'>Cancel</button>
    </form>
  </div>
</div>
